<template>
    <div id="app_topmenu" class="grc_fullwidth_lane TopMenu_lane" style="padding-right:0px;">
        <div class="grc_maincont_lane">
        <div id="TopMenu">
            <table style="width:100%; height:50px;" cellspacing="0" cellpadding="0" v-show="AppHeaderVersion==''">
                <tr>
                    <td class="topmenu_icon_large">
                        <img src="../../../public/styles/images/topmenu_logo_nagy.png" style="margin-left:0px; margin-top: 3px;" />
                    </td>
                    <td class="topmenu_icon_small">
                        <img src="../../../public/styles/images/topmenu_logo_kicsi.png" style="margin-left:0px; margin-top: 3px;" />
                    </td>
                    <td>&nbsp;</td>
                </tr>
            </table>

            <table style="width:100%; height:50px;" cellspacing="0" cellpadding="0" v-show="AppHeaderVersion=='fizetoapp'">
                <tr>
                    <td class="topmenu_icon_large_fizetoapp">
                        <img src="../../../public/styles/images/topmenu_logo_nagy.png" style="margin-left:0px; margin-top: 3px;" />
                    </td>
                    <td class="topmenu_icon_small_fizetoapp">
                        <img src="../../../public/styles/images/topmenu_logo_kicsi.png" style="margin-left:0px; margin-top: 3px;" />
                    </td>
                    <td class="title_fizetoapp">Prémium Egészségpénztári fizető felület</td>
                </tr>
            </table>

        </div>
        </div>
    </div>
</template>

<script>


export default {
  name: 'TM',
  components: {
  },
  data () {
        return {
            AppHeaderVersion:"",

        }
  },
  model: {

  },  
  methods:{

      SetAppHeaderVersion(pVersion)
      {
          this.AppHeaderVersion = pVersion;
      },

  },
  created()
  {
    
  }

}


</script>


<style scoped>

    .TopMenu_lane
    {
        width:100%; 
        height:50px;
        box-sizing:border-box; 
        display:block;
        /* background-color:#3F5771; */
        background-color: var(--premblue);
        position: fixed;
        top: 0px;
        z-index: 6000;    
        margin: 0px;
        padding: 0px;
        box-shadow: 0px 3px 5px #ddd;
    }

    #TopMenu
    {
        width:100%; 
        height:50px;
        box-sizing:border-box; 
        background-color: var(--premblue);
        color:#f0f0f0; 
        font-size:24px; 
        line-height: 24px;
        padding:0px;
        margin: 0px;
        font-family: Verdana;
        border-bottom: solid 0px #ccc;  
    }


    .topmenu_icon_large
    {
        width:180px;
    }

    .topmenu_icon_small
    {
        width:50px;
        display:none;
        text-align: center;
    }

    .topmenu_icon_large_fizetoapp
    {
        width:180px;
    }

    .topmenu_icon_small_fizetoapp
    {
        width:50px;
        display:none;
        text-align: center;
    }

    .title_fizetoapp
    {
        font-size: 20px;
        line-height: 24px;
        text-align: center;
        color: #fff;
    }

    @media (max-width:1000px)
    {
        .title_fizetoapp
        {
            font-size: 20px;
            line-height: 24px;
            text-align: right;
            padding-right: 10px;
        }
    }

    @media (max-width:650px)
    {
        .title_fizetoapp
        {
            font-size: 18px;
            line-height: 20px;
            text-align: right;
            padding-right: 10px;
        }
    }

    @media (max-width:570px)
    {
        .title_fizetoapp
        {
            font-size: 14px;
            line-height: 16px;
            text-align: right;
            padding-right: 10px;
        }
    }

    @media (max-width:500px)
    {
        .topmenu_icon_large_fizetoapp
        {
            display:none;
        }

        .topmenu_icon_small_fizetoapp
        {
            display:table-cell;
        }

        .title_fizetoapp
        {
            font-size: 14px;
            line-height: 16px;
            text-align: left;
            padding-right: 10px;
        }

    }

    @media (max-width:300px)
    {
        .topmenu_icon_large
        {
            display:none;
        }

        .topmenu_icon_small
        {
            display:table-cell;
        }

    }


</style>